<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <div class="header wrap flex mb">
      <div class="flex w180 margin">
        <div class="w85">存货编码</div>
        <div class="flex1 border-bottom">{{ data.ProductNo }}</div>
      </div>
      <div class="flex w240 margin">
        <div class="w85">存货名称</div>
        <div class="flex1 border-bottom">{{ data.ProductName }}</div>
      </div>
      <div class="flex w240 margin">
        <div class="w85">存货规格</div>
        <div class="flex1 border-bottom">{{ data.ProductSpec }}</div>
      </div>
      <div class="flex w180 margin">
        <div class="w60">属性</div>
        <div class="flex1 border-bottom">{{ data.PropertyName }}</div>
      </div>
      <div class="flex w180 margin">
        <div class="w60">颜色</div>
        <div class="flex1 border-bottom">{{ data.ColorName }}</div>
      </div>
    </div>

    <div class="filter-container" style="border-bottom: 0; margin-bottom: 0">
      <el-row class="filter-top" type="flex" justify="end">
        <el-col :span="6">
          <slot name="toolbar-left">
            <span class="span-top-text">查询结果</span>
          </slot>
        </el-col>
        <el-col :span="18">
          <div style="text-align: right">
            <slot name="toolbar-right"></slot>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-table
      class="tb-head-color"
      :border="true"
      row-key="warehousingdetail"
      :data="tableData"
      :row-style="{ height: '40px' }"
      :cell-style="{ padding: '0px' }"
      style="width: 100%; margin-bottom: 20px"
    >
      <el-table-column label="类型" prop="PreType" width="200"></el-table-column>
      <el-table-column label="单据编码" prop="DocNo" width="160">
        <template slot-scope="{ row }">
          <el-link type="primary" @click="toPage(row)">{{ row.DocNo }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="单据类型" prop="DocType"></el-table-column>
      <el-table-column label="主单位" prop="BaseUnitName"></el-table-column>
      <el-table-column label="主单位在途量" prop="BaseQuantity" align="right">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.BaseQuantity) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="客户" prop="ClothTradeUnitName"></el-table-column> -->
      <el-table-column label="供应商/加工商" prop="TradeUnitName"></el-table-column>
      <el-table-column label="部门" prop="DpName"></el-table-column>
      <el-table-column label="完成时间" prop="EndTime">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toDateString(row.EndTime) }}</span>
        </template></el-table-column
      >
      <el-table-column label="辅单位" prop="SubUnitName"></el-table-column>
      <el-table-column label="辅单位在途量" prop="SubQuantity" align="right">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.SubQuantity) }}</span>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      style="margin-top: 5px; float: right"
      :page-size.sync="pageParams.pageSize"
      :page-sizes="[10, 15, 20, 50]"
      :current-page.sync="pageParams.pageIndex"
      :layout="isMB ? MBpageLayout : pageLayout"
      :total="listTotal"
      @size-change="onPageSizeChange"
      @current-change="onPageIndexChange"
    />

    <injection-detail-dialog ref="injectionDetailDialog" :StageName="StageName" :Stage="Stage"></injection-detail-dialog>
    <detail-dialog ref="detailDialog" :StageName="StageName" :Stage="Stage"></detail-dialog>
  </div>
</template>
<script>
import detailDialog from '@/components/production/ticketmanagement/newworkorder/currency/detailDialog'
import injectionDetailDialog from '@/components/production/ticketmanagement/workorder/glue/detailDialog'
import curdMixins from '@/mixins/trend/curd'

export default {
  components: { detailDialog, injectionDetailDialog, curdMixins },
  data() {
    return {
      api: require('@/api/stock/stReport').default,
      trendShow: true,
      tableData: [],
      ProductName: '',
      pageParams: {
        pageSize: this.pageSize || this.$store.state.sys.pageSize, //分页大小
        pageIndex: 1
      },
      data: {
        ProductNo: '',
        ProductName: '',
        ProductSpec: '',
        PropertyName: '',
        ColorName: ''
      },
      tempParams: {},
      isMB: this.$store.state.isMB,
      MBpageLayout: 'total, sizes',
      pageLayout: 'sizes, prev, pager, next, total, jumper',
      StageName: '',
      Stage: 0
    }
  },

  created() {
    this.callApi()
  },
  activated() {
    this.getRouterInfo()
  },
  computed: {
    listTotal() {
      return this.tableData.filter(item => item.PreType !== '小计' && item.PreType !== '合计').length
    }
  },
  methods: {
    callApi(params = {}) {
      this.api.preReleaseList({ ...params }).then(res => {
        if (res.Code === 0) {
          this.tableData = res.Data
        }
      })
    },
    toPage(row) {
      let PreType = row.PreType
      let params = {
        DocNo: row.DocNo,
        DocType: row.DocType,
        type: '明细',
        SourcePage: '预计出库明细',
        IsRelease: row.IsRelease,
        IsWorkDoc: row.IsWorkDoc,
        Stage: row.Stage,
        StageName: row.StageName
      }
      if (PreType === '生产待入量' || PreType === '委外待入量' || PreType === '生产（材料）待发量' || PreType === '委外（材料）待发量') {
        if (row.DocType == '注塑工单') {
          this.$refs.injectionDetailDialog.openDetailsById(row.WorkDocId).then(that => {
            that.inDialog = true
          })
          // this.$router.push({ name: "injection", params: params });
        } else {
          this.$refs.detailDialog.openDetailsById(row.WorkDocId).then(that => {
            that.inDialog = true
          })
          // this.$router.push({ name: "newworkorder", params: params });
        }
      } else if (PreType === '采购在途量') {
        this.$router.push({ name: 'emptor', params: params })
      } else if (PreType === '销售待发量') {
        this.$router.push({ name: 'saleorder', params: params })
      }
    },
    getRouterInfo() {
      if (this.$router.history.current.params.ProductId) {
        let params = this.$router.history.current.params
        this.data = params
        console.log('params', params)
        this.tempParams = {
          ProductId: params.ProductId,
          ColorId: params.ColorId,
          PropertyId: params.PropertyId
        }
        this.callApi(this.tempParams)
        // this.$refs.list.getData()
        // this.params={}
      }
    },
    summaryMethod(param) {
      const { columns, data } = param
      const sums = []
      console.log('columns', columns)
      console.log('data', data)

      // 获取非小计的行数据
      let _data = data.filter(item => item.Type !== '小计')

      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (column.property == 'UnitQuantity' || column.property == 'SubUnitQuantity') {
          const values = _data.map(item => Number(item[column.property]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + curr
              } else {
                return prev
              }
            }, 0)
          }
        }
      })

      return sums
    },
    toSum(arr) {
      let arrLength = arr.length
      let sum = 0
      let subSum = 0
      for (let i = 0; i < arrLength; ++i) {
        sum = sum + arr[i].UnitQuantity
        subSum = subSum + arr[i].SubUnitQuantity
      }

      return {
        Type: '小计',
        DocType: '',
        DocNo: '',
        UnitName: '',
        UnitQuantity: sum,
        SubUnitName: '',
        SubUnitQuantity: subSum
      }
    },
    onPageSizeChange() {},
    onPageIndexChange() {}
  }
}
</script>

<style lang="scss" scoped>
.header {
  margin-top: 18px;
  margin-left: 18px;
}
.flex {
  display: flex;
}
.wrap {
  flex-wrap: wrap;
}
.w240 {
  width: 280px;
}
.w180 {
  width: 180px;
}
.w85 {
  width: 85px;
}
.w60 {
  width: 60px;
}
.flex1 {
  flex: 1;
}
.border-bottom {
  border-bottom: 1px solid #ccc;
}

.margin {
  margin-right: 24px;
  margin-bottom: 18px;
}

.mb {
  margin-bottom: 18px;
}
</style>
